import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-boolean',
    templateUrl: './icon-boolean.component.html',
    styleUrls: ['./icon-boolean.component.less']
})
export class IconBooleanComponent {
    @Input() checked = true;
    @Input() size = 'sm';
}
